var rumBlockstatDict = null;

function rumLoadDict(callback) {
    var dict = localStorage['rumBlockstat'];

    if (dict) {
        callback(JSON.parse(dict));
    } else {
        fetch('https://api.stat.yandex-team.ru/_api/dictionary/_blockstat/', {
            credentials: 'include'
        }).then(function(response) {
            return response.json();
        })
            .then(function(data) {
                rumSaveDict(data);

                callback(data);
            });
    }
}

function rumSaveDict(dict) {
    localStorage['rumBlockstat'] = JSON.stringify(dict);
}

function rumDecode(name) {
    if (!rumBlockstatDict) {
        return name;
    }

    var res = [],
        parts = name.split('.'),
        part,
        bsName;

    for (var i = 0, l = parts.length; i < l; i++) {
        part = parts[i];
        bsName = rumBlockstatDict[part];

        if (!bsName) {
            console.warn('name', part, 'not found at blockstat');

            return name;
        }

        res.push(bsName);
    }

    return res.join('.');
}

rumLoadDict(function(dict) {
    rumBlockstatDict = dict;

    Ya.Rum.debug = function() {
        Ya.Rum.send = function(link, path, vars, clck, tree, sts, counterParams) {
            var varsToDecode = {
                    page: 1,
                    subpage_name: 1,
                    id: 1
                },
                varsArr = vars.split(','),
                varsPretty = {},
                logFields = function(fields) {
                    for (var name in fields) {
                        if (fields.hasOwnProperty(name)) {
                            console.log('%c' + name + '=' + fields[name], 'color: #c1470b;');
                        }
                    }
                };

                varsArr.forEach(function(pair) {
                var arr = pair.split('='),
                    name = arr[0],
                    value = arr[1];

                if (rumDecode(name) === 'ua') {
                    value = '(debug)...';
                }

                varsPretty[rumDecode(name)] = varsToDecode[rumDecode(name)] ? rumDecode(value) : value;
            });

            console.group('%c' + rumDecode(path), 'color: #3333ee;');

            if (rumDecode(path) === 'tech.perf.time') {
                var fields = {};

                if (varsPretty.subpage_name) {
                    fields[varsPretty.id] = Math.floor(varsPretty.time) - Math.floor(varsPretty['action.start_time']);

                    fields[varsPretty.id] += ' [' + varsPretty.subpage_name + '][' + varsPretty.subpage_index + ']';
                } else {
                    fields[varsPretty.id] = Math.floor(varsPretty.time);
                }

                logFields(fields);
            }

            if (rumDecode(path) === 'tech.perf.delta') {
                var fields = {};
                fields[varsPretty.id] = varsPretty.delta;

                if (varsPretty.subpage_name) {
                    fields[varsPretty.id] += ' [' + varsPretty.subpage_name + '][' + varsPretty.subpage_index + ']';
                }

                logFields(fields);
            }

            console.dir(varsPretty);

            if (counterParams) {
                console.log(counterParams);
            }

            console.groupEnd();
        };
    };

    Ya.Rum.debug();
});
